export default __webpack_public_path__ + "static/media/IconFilter.c103c813.svg";